
import React from 'react';
import { Users, PieChart, Search, GraduationCap } from 'lucide-react';
import { FaTiktok } from "react-icons/fa";
import { Card } from '@/components/ui/card';

const userCategories = [
  {
    icon: Users,
    title: "Content Curators",
    description: "Perfect for managing multiple collections and organizing content libraries"
  },
  {
    icon: PieChart,
    title: "Brand Strategists",
    description: "Track trends and maintain brand content archives efficiently"
  },
  {
    icon: Search,
    title: "Researchers",
    description: "Gather and analyze TikTok content for studies and reports"
  },
  {
    icon: FaTiktok,
    title: "TikTok Power Users",
    description: "Save and organize your favorite TikTok content collections"
  },
  {
    icon: GraduationCap,
    title: "Educators",
    description: "Build educational content libraries for teaching and research"
  }
];

const WhosItFor = () => {
  return (
    <section className="py-24 bg-gradient-to-b from-[#151823] to-[#1A1E2C]">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1A1E2C] text-[#00E5FF]">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 9C11.6569 9 13 7.65685 13 6C13 4.34315 11.6569 3 10 3C8.34315 3 7 4.34315 7 6C7 7.65685 8.34315 9 10 9Z" fill="#00E5FF"/>
              <path d="M3 18C3 14.134 6.13401 11 10 11C13.866 11 17 14.134 17 18" stroke="#00E5FF" strokeWidth="2" strokeLinecap="round"/>
              <path d="M15 6C16.6569 6 18 4.65685 18 3M15 6C13.3431 6 12 4.65685 12 3M15 6C15 7.65685 16.3431 9 18 9M15 6C15 7.65685 13.6569 9 12 9M5 6C3.34315 6 2 4.65685 2 3M5 6C6.65685 6 8 4.65685 8 3M5 6C5 7.65685 3.65685 9 2 9M5 6C5 7.65685 6.34315 9 8 9" stroke="#00E5FF" strokeWidth="2" strokeLinecap="round"/>
            </svg>
            Who It's For
          </span>
          <h2 className="text-5xl font-bold text-white mt-4 mb-6">
            Perfect For TikTok Power Users
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-lg">
            Easily and instantly download any TikTok collection with 1 click!
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
          {userCategories.map((category, index) => (
            <Card 
              key={category.title}
              className="group bg-[#1E2232]/60 border-gray-800 p-6 hover:bg-[#1E2232]/80 transition-all duration-300 hover:scale-105"
            >
              <div 
                className="w-12 h-12 bg-[#00E5FF]/10 rounded-lg flex items-center justify-center mb-4 group-hover:bg-[#00E5FF]/20 transition-colors"
              >
                {React.createElement(category.icon, {
                  className: "w-6 h-6 text-[#00E5FF]",
                  style: {
                    animation: `floating ${3 + index * 0.2}s ease-in-out infinite`
                  }
                })}
              </div>
              <h3 className="text-lg font-medium text-white mb-2">{category.title}</h3>
              <p className="text-sm text-gray-400">{category.description}</p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhosItFor;

